import { API_CONFIG, apiUtils } from '../config.js';

// Statistics API for dashboard and reports
export const statisticsApi = {
  // Get dashboard statistics
  getDashboardStats: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/statistics/dashboard?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get user statistics
  getUserStats: async () => {
    const url = `${API_CONFIG.BASE_URL}/statistics/users`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get student statistics
  getStudentStats: async () => {
    const url = `${API_CONFIG.BASE_URL}/statistics/students`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get class statistics
  getClassStats: async () => {
    const url = `${API_CONFIG.BASE_URL}/statistics/classes`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get attendance statistics
  getAttendanceStats: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/statistics/attendance?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get fee statistics
  getFeeStats: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/statistics/fees?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get result statistics
  getResultStats: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/statistics/results?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get calendar statistics
  getCalendarStats: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/statistics/calendar?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get notice statistics
  getNoticeStats: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/statistics/notices?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get teacher statistics
  getTeacherStats: async (teacherId) => {
    const url = `${API_CONFIG.BASE_URL}/statistics/teacher/${teacherId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get class performance statistics
  getClassPerformanceStats: async (classId, academicYear) => {
    const queryParams = apiUtils.buildQueryString({ classId, academicYear });
    const url = `${API_CONFIG.BASE_URL}/statistics/class-performance?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },
};

export default statisticsApi;
